<template>
  <div id="app">
    <router-view/>
    <loginPopup/>
    <AIPopup/>
  </div>
</template>

<script>
import loginPopup from "./components/body/viewh/login";
import AIPopup from "./components/AIPopup";

export default {
  name: "App",
  components: {
    loginPopup,
    AIPopup
  },
};
</script>

<style>
@import url("./assets/css/app.css");

/* @import "./assets/font/font.css"; */

.el-message-box {
  width: 80% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue